e4.download.list.bindEvents         = function () {

    jQuery( '.js-e-productlist-download' ).on( 'update.e4.productlist', function ( event ) {
        jQuery('.js-e-productslist-header').find('.js-e-download-addall').prop('disabled', true);
        jQuery('.js-e-productslist-header').find('.js-e-download-removeall').prop('disabled', true);
    } );

    jQuery( '.js-e-productlist-download' ).on( 'builded.e4.productlist', function ( event ) {
        e4.download.list.toogleIsInCart();
        jQuery( event.target ).find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
            e4.product.validateForm( domForm );
        } );
    } );

    jQuery( '.js-e-download-search-form' ).on( 'submit', function ( event ) {
        event.preventDefault();
        var jForm            = jQuery( event.target ),
            jProductlistForm = jQuery( '.js-e-productlist-form' );
        jProductlistForm.find( '.js-e-search-input' ).val( jForm.find( '.js-e-search-input' ).val() );
        jProductlistForm.trigger( 'submit' );
        return false;
    } );
    if(jQuery('.js-e-download-search-form').length > 0){
        jQuery('.js-il-search-form').parent().remove();
    }
    //jQuery( '.js-e-download-cart-email-add-btn' ).on( 'click', e4.download.cart.addEmail );
    e4.productlist.jProductList.on( 'builded.e4.productlist', e4.download.list.appendAddAllButton );
};

e4.download.list.appendAddAllButton = function () {
    if(jQuery('.js-e-productlist-download').length > 0 && jQuery('.js-e-download-addall').length == 0){
        jQuery('.js-il-productlist-downloadmanager-cart-btn-container').append( '<div class="alert alert-warning text-left"><p class="m-0 p-0"><i class="material-icons material-icons-large">info</i>{{text}}</p></div>'.replace('{{text}}', e4.productlist.jProductList.data( 'infoboxLimitedDownloadText')));

        jQuery('.js-il-productlist-downloadmanager-cart-btn-container').append( '<button class="btn btn-primary btn-sm js-e-download-addall mt-2" type="button"><i class="material-icons material-icons-large text-success">add</i>{{text}}</button>'.replace( '{{text}}', e4.productlist.jProductList.data( 'addAllButtonText' ) ) );
        jQuery( '.js-e-download-addall' ).on( 'click', e4.download.list.addAll );

        jQuery('.js-il-productlist-downloadmanager-cart-btn-container').append( '<button class="btn btn-primary btn-sm js-e-download-removeall ml-2 mt-2" type="button"><i class="material-icons material-icons-large text-danger">remove</i>{{text}}</button>'.replace( '{{text}}', e4.productlist.jProductList.data( 'removeAllButtonText' ) ) );
        jQuery( '.js-e-download-removeall' ).on( 'click', e4.download.list.removeAll );
    }
};
e4.download.cart.addEmail = function () {
    var jControlGroupEmail    = jQuery( '.js-e-download-cart-email-control-group' ),
        jControlGroupEmailNew = jControlGroupEmail.first().clone();
    //
    jControlGroupEmailNew.find( '.js-e-download-cart-email' ).attr( 'id', function () {
        return this.id + new Date().getTime();
    } ).val( '' );
    jControlGroupEmailNew.find('label').remove();
    jControlGroupEmail.last().after( jControlGroupEmailNew );
    jControlGroupEmailNew.append('<button class="btn btn-sm btn-tertiary js-il-download-cart-email-delete-btn il-download-cart-email-delete-btn" href="" tabindex="-1"><i class="material-icons">close</i></button>');
    jControlGroupEmailNew.find( '.js-e-download-cart-email' ).trigger( 'focus' );
};
e4.download.cart.removeEmail = function ( event ) {
    jQuery(event.target).closest('.js-e-download-cart-email-control-group').remove();
};

e4.download.list.removeAll = function () {
    var strUrlParam = 'cartcmd=emptycart&OrderContext=Download';
    jQuery.ajax( {
        method: 'GET',
        dataType: 'json',
        url: e4.settings.ecom.download.url,
        cache: false,
        data: strUrlParam,
        beforeSend: function () {
            jQuery('.js-e-productslist-header').find('.js-e-download-addall').prop('disabled', true);
            jQuery('.js-e-productslist-header').find('.js-e-download-removeall').prop('disabled', true);
            jQuery( '.js-e-products-loading-overlay' ).addClass( 'is-loading' );
            jQuery('.js-e-products-loading-overlay').find('.js-loading-remove-text').removeClass('d-none');
        }
    } ).fail( function ( jqXHR, textStatus, errorThrown ) {
        console.error( jqXHR, textStatus, errorThrown );
    } ).always( function () {
        e4.download.list.removeAllCallback();
    } );
};
e4.download.list.removeAllCallback     = function () {
    e4.download.ajax( {
        method: 'GET'
    }, function ( jsonData ) {
        e4.download.cart.updateQuantity( jsonData.cart.productLinesCount );
        e4.download.limitedDownload.toggleAddRemoveAllButton(jsonData.cart.productLinesCount);
        e4.productlist.jProductList.find( '.js-e-products-item' ).removeClass( 'is-in-cart' );
        jQuery( '.js-e-products-loading-overlay' ).removeClass( 'is-loading' );
        jQuery('.js-e-products-loading-overlay').find('p').addClass('d-none');
    } );
};

e4.download.list.addAll = function () {
    var strUrlParam = e4.productlist.jProductList.find( '.js-e-productlist-form' ).serialize();
    strUrlParam += '&AddAllProductsByQueryToDMContextCart=true';
    jQuery.ajax( {
        method: 'GET',
        dataType: 'json',
        url: e4.settings.ecom.download.url,
        cache: false,
        data: strUrlParam,
        beforeSend: function () {
            jQuery('.js-e-productslist-header').find('.js-e-download-addall').prop('disabled', true);
            jQuery('.js-e-productslist-header').find('.js-e-download-removeall').prop('disabled', true);
            jQuery( '.js-e-products-loading-overlay' ).addClass( 'is-loading' );
            jQuery('.js-e-products-loading-overlay').find('.js-loading-add-text').removeClass('d-none');
        }
    } ).fail( function ( jqXHR, textStatus, errorThrown ) {
        console.error( jqXHR, textStatus, errorThrown );
    } ).always( function () {
        e4.download.list.addAllCallback();
    } );
};
e4.download.list.addAllCallback     = function () {
    e4.download.ajax( {
        method: 'GET'
    }, function ( jsonData ) {
        e4.download.cart.updateQuantity( jsonData.cart.productLinesCount );
        e4.download.limitedDownload.toggleAddRemoveAllButton(jsonData.cart.productLinesCount);
        e4.productlist.jProductList.find( '.js-e-products-item' ).addClass( 'is-in-cart' );
        jQuery( '.js-e-products-loading-overlay' ).removeClass( 'is-loading' );
        jQuery('.js-e-products-loading-overlay').find('p').addClass('d-none');
    } );
};

e4.download.cart.bindEvents = function () {
    jQuery( '.js-e-download-cart-email-add-btn' ).on( 'click', e4.download.cart.addEmail );
    jQuery('.js-e-download-cart').on('click', '.js-il-download-cart-email-delete-btn', e4.download.cart.removeEmail);
    jQuery('.js-e-download-cart-form').on('submit', function ( event ) {
        if(jQuery(event.target).valid()){
            jQuery(event.target).find('.js-download-alert').removeClass('d-none');
        }
    });
};

e4.download.limitedDownload = {
    maxDownloadLimit: 800,
    maxProductlistLimit: 170,
    toggleAddRemoveAllButton: function(intOrderlineCount){
        var intDiffCount = e4.download.limitedDownload.maxDownloadLimit - ( intOrderlineCount + e4.productlist.data.productCount );
        if(intDiffCount <= 0){
            jQuery('.js-e-productslist-header').find('.js-e-download-addall').prop('disabled', true);
        } else {
            if(e4.productlist.data.productCount <= e4.download.limitedDownload.maxProductlistLimit){
                jQuery('.js-e-productslist-header').find('.js-e-download-addall').prop('disabled', false);
            } else {
                jQuery('.js-e-productslist-header').find('.js-e-download-addall').prop('disabled', true);
            }
        }
        if(intOrderlineCount > 0){
            jQuery('.js-e-productslist-header').find('.js-e-download-removeall').prop('disabled', false);
        } else {
            jQuery('.js-e-productslist-header').find('.js-e-download-removeall').prop('disabled', true);
        }
    }
};
